
import SpecialSalaryPatternEditPage from './SpecialSalaryPatternEditPage';

export default SpecialSalaryPatternEditPage;
